import { useState } from "react";
import {
  RequestGetListingsItemsRequest,
  AmazonListingsItemsPostRequest,
  AmazonApi,
  ResponseListingsItemsResult,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";
import axios from "axios";

export const useApiGetListingsItems = () => {
  const [listingsItems, setListingsItems] =
    useState<ResponseListingsItemsResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getListingsItems = async (req: RequestGetListingsItemsRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: AmazonListingsItemsPostRequest = { req };
      const api = new AmazonApi(config);

      const response = await api.amazonListingsItemsPost(request);
      // 商品キャッシュが空のため同期を開始した場合は検索結果が無い。
      // 呼び出し側で同期の完了を待ってから再検索する（空の一覧は表示しない）
      if (!response.syncStarted) {
        setListingsItems(response);
      }
      return response;
    } catch (err) {
      console.error(err);
      console.error(axios.isAxiosError(err));

      if (axios.isAxiosError(err)) {
        const status = err.response?.status;
        if (status === 404) {
          setError("出品者IDが見つかりません");
        } else if (status === 502) {
          setError("Amazon APIの取得に失敗しました");
        } else if (status === 400) {
          setError("リクエストに不備があります");
        } else {
          setError("予期しないエラーが発生しました");
        }
      } else {
        setError("通信エラーが発生しました");
      }
    } finally {
      setIsLoading(false);
    }

    return null;
  };

  return {
    getListingsItems,
    listingsItems,
    setListingsItems,
    error,
    isLoading,
  };
};
